import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import {
    TabularTypeDatasetAdapter,
    tabularTypeDatasetAdapts
} from 'app/model/adapters/datasets/tabular-type.dataset.adapter';
import { Metamodel } from 'app/model/base/model';
import { Model } from 'app/model/backendmodel';
import { OracleFusionTableDataset } from 'app/model/dataset/oracle-fusion.dataset';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(OracleFusionTableDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class OracleFusionTableDatasetAdapter extends TabularTypeDatasetAdapter<
    OracleFusionTableDataset,
    Model.DatasetResource
> {
    protected async _toResource(dataset: OracleFusionTableDataset): Promise<Model.DatasetResource> {
        return this._toResourceInternal(dataset, Metamodel.modelFor(OracleFusionTableDataset).name);
    }

    protected async _toModel(
        resource: Model.DatasetResource,
        dataset?: OracleFusionTableDataset
    ): Promise<OracleFusionTableDataset> {
        return this._toModelInternal(resource, dataset, OracleFusionTableDataset.MODEL);
    }
}